import React from 'react'
import {Link, Icon} from '../'
import * as Paths from '../../constants/Paths'
import AppState from '../../state/AppState';

class Navbar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null
    }

  }

  render() {

    const { className, AppState } = this.props;

    return (
      <div className={"Navbar " + (className ? " " + className : "")}>
        <div className="grid-row v-align top-section">
          <div className="grid-item logo grid-row v-align">
            <Link href={Paths.HOME} className="grid-row v-align">
              <div className="sr2">
                <Icon name="logo1"/>
              </div>
              SnapTest
            </Link>
          </div>
          <div className="grid-item grid-row v-align nav-items nav-items-desktop">
            <Link className="grid-item nav-item" href={Paths.DOCS}>Docs</Link>
            <Link className="grid-item nav-item" href={Paths.BLOG}>Blog</Link>
            <Link className="grid-item nav-item" href={Paths.UPDATES}>Updates</Link>
            <Link className="grid-item nav-item" href={Paths.CONTACT}>Contact</Link>
            <Link className="grid-item nav-item" href={Paths.PRICING}>Pricing</Link>
          </div>
          <div className="grid-item login grid-row r-align">
            {AppState.user ? (
              <Link href={Paths.DB_USER_HOME}>My dashboard</Link>
            ) : (
              <Link href={Paths.LOGIN}>Login</Link>
            )}
          </div>
          <div className="social-links grid-row">
            <div className="social-link">
              <a href="https://github.com/snaptest-io/snaptest-extension" title="GitHub" className="css-ofs7zu">
                <svg fill="currentColor"
                     preserveAspectRatio="xMidYMid meet"
                     height="1em"
                     width="1em"
                     viewBox="0 0 40 40"
                     style={{verticalAlign: 'middle'}}>
                  <g>
                    <path d="m20 0c-11 0-20 9-20 20 0 8.8 5.7 16.3 13.7 19 1 0.2 1.3-0.5 1.3-1 0-0.5 0-2 0-3.7-5.5 1.2-6.7-2.4-6.7-2.4-0.9-2.3-2.2-2.9-2.2-2.9-1.9-1.2 0.1-1.2 0.1-1.2 2 0.1 3.1 2.1 3.1 2.1 1.7 3 4.6 2.1 5.8 1.6 0.2-1.3 0.7-2.2 1.3-2.7-4.5-0.5-9.2-2.2-9.2-9.8 0-2.2 0.8-4 2.1-5.4-0.2-0.5-0.9-2.6 0.2-5.3 0 0 1.7-0.5 5.5 2 1.6-0.4 3.3-0.6 5-0.6 1.7 0 3.4 0.2 5 0.7 3.8-2.6 5.5-2.1 5.5-2.1 1.1 2.8 0.4 4.8 0.2 5.3 1.3 1.4 2.1 3.2 2.1 5.4 0 7.6-4.7 9.3-9.2 9.8 0.7 0.6 1.4 1.9 1.4 3.7 0 2.7 0 4.9 0 5.5 0 0.6 0.3 1.2 1.3 1 8-2.7 13.7-10.2 13.7-19 0-11-9-20-20-20z" /></g>
                </svg>
              </a>
            </div>
            <div className="social-link">
              <a href="https://twitter.com/SnapTestIO" title="Twitter" className="css-ofs7zu">
                <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="1em" width="1em" viewBox="0 0 40 40" style={{verticalAlign: 'middle'}}><g><path d="m37.7 9.1q-1.5 2.2-3.7 3.7 0.1 0.3 0.1 1 0 2.9-0.9 5.8t-2.6 5.5-4.1 4.7-5.7 3.3-7.2 1.2q-6.1 0-11.1-3.3 0.8 0.1 1.7 0.1 5 0 9-3-2.4-0.1-4.2-1.5t-2.6-3.5q0.8 0.1 1.4 0.1 1 0 1.9-0.3-2.5-0.5-4.1-2.5t-1.7-4.6v0q1.5 0.8 3.3 0.9-1.5-1-2.4-2.6t-0.8-3.4q0-2 0.9-3.7 2.7 3.4 6.6 5.4t8.3 2.2q-0.2-0.9-0.2-1.7 0-3 2.1-5.1t5.1-2.1q3.2 0 5.3 2.3 2.4-0.5 4.6-1.7-0.8 2.5-3.2 3.9 2.1-0.2 4.2-1.1z" /></g></svg>
              </a>
            </div>
          </div>
        </div>
        <div className="nav-items nav-items-mobile">
          <Link className="grid-item nav-item" href={Paths.DOCS}>Docs</Link>
          <Link className="grid-item nav-item" href={Paths.BLOG}>Blog</Link>
          <Link className="grid-item nav-item" href={Paths.UPDATES}>Updates</Link>
          <Link className="grid-item nav-item" href={Paths.CONTACT}>Contact</Link>
          <Link className="grid-item nav-item" href={Paths.PRICING}>Pricing</Link>
        </div>
      </div>
    )
  }

}

export default AppState.connect(React, Navbar);



// WEBPACK FOOTER //
// ./src/components/marketing/Navbar.js